import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTextfield = styled(TextField)({
  "& .MuiInputBase-root.MuiInput-root:before": {
    content: '""',
    border: "none",
  },
});
